import React, { Component, Fragment } from "react";
import { submit } from "redux-form";
import TitledForm from "../../Helpers/TitledForm";
import LandlordAccountForm from "./LandlordAccountForm";
import LinkHelper from "../../Helpers/Link";
import { Button } from "@material-ui/core";
import SignUpStatus from "../../Helpers/SignUpStatus";
import LoginSuggestion from "../../Helpers/LoginSuggestion";
import { connect } from "react-redux";
import { validateBaseSignup } from "../../../actions/validation";

class LandlordAccount extends Component {

    constructor( props ) {
        super( props );
        this.handleChange = this.handleChange.bind( this );
        this.setValidity = this.setValidity.bind( this );
        this.state = {
            validity: undefined
        };
    }

    handleChange( values, dispatch, props, previousValues ) {
        console.log( "[:::CHANGE:::]", values ); // DEBUG
        this.setValidity( values );
        if ( this.props.onChange )
            this.props.onChange( values, dispatch, props, previousValues );
    }

    setValidity( values ) {
        const validity = validateBaseSignup( values, true );
        this.setState({
            validity
        });
    }

    isValid( validity ) {
        console.log('validity',validity)
        return validity !== undefined && !Object.keys( validity ).length;
    }

    render() {
        const { manualSubmit, handleSubmit, email } = this.props;
        return (
            <TitledForm
                stretch
                titleAlign="left"
                titleSize="wide"
                formSize="wide"
                formAlign="stretch"
                title="Welcome to Sopia! Please sign up your account."
                form={
                    <LandlordAccountForm
                        validity={this.state.validity}
                        onSubmit={handleSubmit}
                        onChange={this.handleChange}
                    />
                }
                footer={
                    <Fragment>
                        <div className="Content-options">
                            <LinkHelper to="/signup">
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="large"
                                >
                                    Back
                                </Button>
                            </LinkHelper>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                disabled={!this.isValid( this.state.validity )}
                                onClick={() => manualSubmit( "landlordAccount" )}
                            >
                                Sign up
                            </Button>
                        </div>
                        <LoginSuggestion/>
                        <SignUpStatus email={email}/>
                    </Fragment>
                }
            />
        );
    }
}

export default connect(
    state => {
        return {
            email: state.signUp.email
        };
    },
    dispatch => {
        return {
            manualSubmit: ( form ) => dispatch( submit( form ) )
        };
    }
)( LandlordAccount );